"use client"

import dynamic from "next/dynamic"
import { DeferredHydration } from "@/components/client/DeferredHydration"

const GlobalFooterClient = dynamic(
  () => import("@/components/client/GlobalFooterClient"),
  { ssr: false },
)

type DeferredGlobalFooterProps = {
  logo: { url: string; alt?: string } | null
  globalFooterText?: string
  legalStuff?: any[]
}

export default function DeferredGlobalFooter(props: DeferredGlobalFooterProps) {
  return (
    <DeferredHydration minHeight="120px">
      <GlobalFooterClient {...props} />
    </DeferredHydration>
  )
}
